// 半自动
const semiAutomatic = [
    {
        label: 'Draco 810E',
        value: 'Draco810E',
    },
    {
        label: 'Draco 810S',
        value: 'Draco810S',
    },
    {
        label: 'Draco 820E',
        value: 'Draco820E',
    },
    {
        label: 'Draco 820S',
        value: 'Draco820S',
    },
    {
        label: 'Draco 830E',
        value: 'Draco830E',
    },
    {
        label: 'Draco 830S',
        value: 'Draco830S',
    },
    {
        label: 'Draco 850M',
        value: 'Draco850M',
    },
    {
        label: 'Draco 850S',
        value: 'Draco850S',
    },
    {
        label: 'Draco 860E',
        value: 'Draco860E',
    },
    {
        label: 'Draco 860S',
        value: 'Draco860S',
    },
    {
        label: 'Draco 860M',
        value: 'Draco860M',
    },
    {
        label: 'Draco 870M',
        value: 'Draco870M',
    },
    {
        label: 'Draco 880M',
        value: 'Draco880M',
    },
    {
        label: 'Draco 890M',
        value: 'Draco890M',
    },
];

// 全自动
const fullyAutomatic = [
    {
        label: 'Draco 910E',
        value: 'Draco910E',
    },
    {
        label: 'Draco 910S',
        value: 'Draco910S',
    },
    {
        label: 'Draco 920E',
        value: 'Draco920E',
    },
    {
        label: 'Draco 920S',
        value: 'Draco920S',
    },
    {
        label: 'Draco 930E',
        value: 'Draco930E',
    },
    {
        label: 'Draco 930S',
        value: 'Draco930S',
    },
    {
        label: 'Draco 950S',
        value: 'Draco950S',
    },
    {
        label: 'Draco 950M',
        value: 'Draco950M',
    },
    {
        label: 'Draco 960E',
        value: 'Draco960E',
    },
    {
        label: 'Draco 960M',
        value: 'Draco960M',
    },
    {
        label: 'Draco 960S',
        value: 'Draco960S',
    },
    {
        label: 'Draco 970M',
        value: 'Draco970M',
    },
    {
        label: 'Draco 980M',
        value: 'Draco980M',
    },
    {
        label: 'Draco 990M',
        value: 'Draco990M',
    },
];

export const dracoOptions = { 
    draco800: semiAutomatic, 
    draco900: fullyAutomatic 
};
